import { useEffect, useState } from "react";

// One rule for decorative desktop motion; phones, tablets and short windows use stills.
export const DESKTOP_MOTION_QUERY = "(min-width: 1024px) and (min-height: 501px) and (prefers-reduced-motion: no-preference)";

export const useMotionQuery = (mediaQuery) => {
  const [enabled, setEnabled] = useState(() => window.matchMedia(mediaQuery).matches);
  useEffect(() => {
    const query = window.matchMedia(mediaQuery);
    const update = () => setEnabled(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, [mediaQuery]);
  return enabled;
};

export const useDesktopMotion = () => useMotionQuery(DESKTOP_MOTION_QUERY);
